import { useState } from 'react';
import {ReactComponent as ThreeDotsIcon} from '../components/svgs/threeDotsIcon.svg';

const OrderDropdown = ({ options }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="order-dropdown">
        <div className={'icon-container'}
            onClick={toggleDropdown}>
        <ThreeDotsIcon/>
        </div>
            
        {isOpen && (
            <div className="order-dropdown-content">
            {options.map((option, index) => (
                <a href={option.link} key={index}>{option.label}</a>
            ))}
            </div>
        )}
    </div>
  );
};

export default OrderDropdown;
